<template>
  <div class="counters">
    <counter
      v-if="field.maximumWords"
      :type="'words'"
      :value="value"
      :maximum="field.maximumWords"
    >
    </counter>
    <counter
      v-if="field.maximumCharacters"
      :type="'characters'"
      :value="value"
      :maximum="field.maximumCharacters"
    >
    </counter>
  </div>
</template>

<script>
import Counter from './Counter.vue';

export default {
  components: {
    Counter
  },
  props: {
    field: {
      type: Object,
      required: true
    },
    value: {
      type: String,
      default: ''
    }
  }
};
</script>

<style>
.counters {
  display: block;
  float: right;
  margin-bottom: 5px;
}
</style>
